import { Enumify } from "enumify-ts";
class DimensionUnitType extends Enumify() {
    description;
    static M = new DimensionUnitType("Metre");
    static CM = new DimensionUnitType("Centimetre");
    static MM = new DimensionUnitType("Millimetre");
    static _ = DimensionUnitType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray(shortUnits = false) {
        return DimensionUnitType.values.map(it => {
            return {
                label: (shortUnits) ? it.key.toLowerCase() : it.description,
                value: it.key
            };
        });
    }
}
export default DimensionUnitType;
